import { DatePicker } from './styles'

export default DatePicker